/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_CATEGORY_DETAILS_REQUEST,
  FETCH_CATEGORY_DETAILS_SUCCESS,
  FETCH_CATEGORY_DETAILS_FAILURE,
} from "./CategoryTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchCategoryDetailsRequest = () => {
  return {
    type: FETCH_CATEGORY_DETAILS_REQUEST,
  };
};

export const fetchCategoryDetailsSuccess = (appData) => {
  return {
    type: FETCH_CATEGORY_DETAILS_SUCCESS,
    payload: appData,
  };
};

export const fetchCategoryDetailsFailure = (error) => {
  return {
    type: FETCH_CATEGORY_DETAILS_FAILURE,
    payload: error,
  };
};

export const fetchCategoryDetails = () => {
  return async function (dispatch) {
    dispatch(fetchCategoryDetailsRequest());
    try {
      const data = await APIManager.getCategories();
      dispatch(fetchCategoryDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchCategoryDetailsFailure(error));
      dispatch(commonError(error,FETCH_CATEGORY_DETAILS_FAILURE));
    }
  };
};

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}
